import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Logo from '../../assets/image/onegml.png'
import GoogleMapReact from 'google-map-react';
import {RadioGroup,FormControlLabel,Radio,TextField,Button,FormControl,InputLabel,Input ,OutlinedInput,CircularProgress} from '@material-ui/core'
import {URL,USER,PASS} from '../../service/base_url'
import Modal from '../../components/modal'
import axios from 'axios'
import {get} from 'lodash'
export default class index extends Component {
    
    state={
        tab_active:'jakarta',
        lat: 51.505,
        lng: -0.09,
        zoom: 13,

        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        message:'',
        loading:false,
        success_form:false,
        department:'',
        jobTitle:''
    }
    onChange=(e)=>{
        e.preventDefault()
        this.setState({[e.target.name]:e.target.value})
    }
    handleDisable=()=>{
        let {name,phoneNumber,email,companyName,department,jobTitle}=this.state
        if(name===''||phoneNumber===''||email===''||companyName===''||department===''||jobTitle===''){
            return true
        }else{
            return false
        }
    }
    submit=()=>{
        this.setState({loading:true})
        let {name,phoneNumber,email,companyName,message,department,jobTitle}=this.state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,department,jobTitle,action:'contact-us',message
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                this.setState({loading:false})

                this.setState({success_form:!this.state.success_form})
            }else{
                this.setState({loading:false})
                alert('Ops something error')
            }
        })
    }
    tabToggle=(data)=>{
        this.setState({tab_active:data})
    }
    toggleSucces=()=>{
        this.setState({success_form:!this.state.success_form})
    }
    children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={this.toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    render() {
        const {tab_active,success_form,loading}=this.state
        const position = [this.state.lat, this.state.lng]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <Modal title="We received your message" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                    <section className='contact'>
                        <div className='head-contact'>
                            <h1>Contact Us</h1>
                            <div className='blue-square hidden-mobile'></div>
                        </div>
                        <div className='head-contact-dot'></div>
                        <br/>
                        <div className='contact-wrapper'>
                            <div className='contact-form'>
                                {/* <form onSubmit={this.submit}> */}
                                
                                <FormControl  className='contact-field' variant="outlined" size="small">
                                    <InputLabel  htmlFor="name">Name <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="name"
                                        type='text'
                                        name='name'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={50}
                                    />
                                </FormControl>
                                <br/>
                                <FormControl  className='contact-field' variant="outlined" size="small">
                                    <InputLabel  htmlFor="name">Company Name <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="companyName"
                                        type='text'
                                        name='companyName'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={130}
                                    />
                                </FormControl>
                                <br/>
                                <FormControl  className='contact-field' variant="outlined" size="small">
                                    <InputLabel  htmlFor="name">Department <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="department"
                                        type='text'
                                        name='department'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={90}
                                    />
                                </FormControl>
                                <br/>
                                <FormControl  className='contact-field' variant="outlined" size="small">
                                    <InputLabel  htmlFor="name">Job Title <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="jobTitle"
                                        type='text'
                                        name='jobTitle'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={70}
                                    />
                                </FormControl>
                                <br/>
                                
                                <FormControl variant="outlined" size="small"  className='contact-field'>
                                    <InputLabel  htmlFor="phoneNumber">Handphone No.<span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="phoneNumber"
                                        type='text'
                                        name='phoneNumber'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={120}
                                    />
                                </FormControl>
                                <br/>
        
                                <FormControl variant="outlined" size="small"  className='contact-field'>
                                    <InputLabel  htmlFor="email">Email <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                       
                                        id="email"
                                        type='email'
                                        name='email'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={70}
                                    />
                                </FormControl>
                                <br/>
                                 <FormControl variant="outlined" size="small" className='contact-field'>
                                    <InputLabel  htmlFor="message">Message <span style={{color:'red'}}>*</span></InputLabel>
                                    <OutlinedInput
                                        
                                        id="message"
                                        type='textarea'
                                        name='message'
                                        onChange={this.onChange}
                                        required
                                        labelWidth={75}
                                        multiline
                                        rows={4}
                                    />
                                </FormControl>
                                <br/>
                                {/* <p>(*.Required</p> */}
                                <Button disabled={this.handleDisable()} onClick={this.submit} className='button-contact' size="small" color="primary" variant="contained">
                                {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                                </Button>
                                {/* </form> */}
                            </div>
                            <div className='contact-location'>
                                <div className='contact-tab'>
                                    <div onClick={()=>this.tabToggle('jakarta')}>
                                        <h6 className={tab_active==='jakarta'?'contact-tab-active':''}>Jakarta</h6>
                                    </div>
                                    <div onClick={()=>this.tabToggle('medan')}>
                                        <h6 className={tab_active==='medan'?'contact-tab-active':''}>Medan</h6>
                                    </div>
                                    <div onClick={()=>this.tabToggle('surabaya')}>
                                        <h6 className={tab_active==='surabaya'?'contact-tab-active':''}>Surabaya</h6>
                                    </div>
                                    <div onClick={()=>this.tabToggle('makassar')}>
                                        <h6 className={tab_active==='makassar'?'contact-tab-active':''}>Makassar</h6>
                                    </div>
                                </div>
                                <div className='contact-tab-content' style={{display:tab_active==='jakarta'?'':'none'}}>
                                    <p>GRAHA GML</p>
                                    <div className='lokasi'>
                                       
                                        <div className='left'>
                                            <p>
                                                Artha Gading Niaga<br/>
                                                Blok B No. 24-25<br/>
                                                Jl. Boulevard Artha Gading,<br/>
                                                Kelapa Gading Barat<br/>
                                                Jakarta 14240
                                            </p>
                                        </div>
                                        <div className='right'>
                                            <p>
                                                021-4585 0861,<br/>
                                                021-451 5718(hunting)<br/>
                                                Fax : 021-4585 0862<br/>
                                                gml@gmlperformance.co.id
                                            </p>
                                        </div>
                                    </div>
                                    <iframe className="map" frameborder="0" style={{border:0}} src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJi0CxzUX1aS4Rp5GuavH7-G4&key=AIzaSyAjE0VJZRVwo1tDD42y0zSR0C_g9yq6XdA" allowfullscreen></iframe>
                                </div>
                                <div className='contact-tab-content' style={{display:tab_active==='medan'?'':'none'}}>
                                    <p>GML PERFORMANCE CONSULTING</p>
                                    <div className='lokasi'>
                                       
                                        <div className='left'>
                                            <p>
                                                Gedung Mandiri, Lt 2<br/>
                                                Jl. Imam Bonjol no 16D,<br/>
                                                Medan 20112<br/>
                                            </p>
                                        </div>
                                        <div className='right'>
                                            <p>
                                                061-77828359<br/>
                                                061-30002345<br/>
                                                061-4156122 ext. 107<br/>
                                                Fax : 061-4156842<br/>
                                                gmlmedan@gmlperformance.co.id
                                            </p>
                                        </div>
                                    </div>
                                    <iframe className="map" frameborder="0" style={{border:0}} src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJT0gnrzQwMTAR49_XI2vPHa8&key=AIzaSyAjE0VJZRVwo1tDD42y0zSR0C_g9yq6XdA" allowfullscreen></iframe>
                                </div>
                                <div className='contact-tab-content' style={{display:tab_active==='surabaya'?'':'none'}}>
                                    <p>GML PERFORMANCE CONSULTING</p>
                                    <div className='lokasi'>
                                       
                                        <div className='left'>
                                            <p>
                                                Wisma BII Lt 7,<br/>
                                                Jl Pemuda No 60-70,<br/> 
                                                Surabaya 60271<br/>
                                            </p>
                                        </div>
                                        <div className='right'>
                                            <p>
                                                031-5355633<br/>
                                                031-91130646<br/>
                                                Fax : 031-5355622<br/>
                                                gmlsurabaya@gmlperformance.co.id
                                            </p>
                                        </div>
                                    </div>
                                    <iframe className="map" frameborder="0" style={{border:0}} src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJkWrtlWL51y0R2mRwcdCYk3M&key=AIzaSyAjE0VJZRVwo1tDD42y0zSR0C_g9yq6XdA" allowfullscreen></iframe>
                                </div>
                                <div className='contact-tab-content' style={{display:tab_active==='makassar'?'':'none'}}>
                                    <p>GML PERFORMANCE CONSULTING</p>
                                    <div className='lokasi'>
                                       
                                        <div className='left'>
                                            <p>
                                                Gedung Fajar Graha Pena Lantai 1,<br/>
                                                Kavling 105 G, <br/>
                                                Jl. Urip Sumoharjo No. 20,<br/>
                                                Makassar 90234<br/>

                                            </p>
                                        </div>
                                        <div className='right'>
                                            <p>
                                                0411-422068<br/>
                                                gmlmakassar@gmlperformance.co.id
                                            </p>
                                        </div>
                                    </div>
                                    <div className='map'>
                                    <iframe className="map" frameborder="0" style={{border:0}} src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJYQIL_DX9vi0RurAiJqFMTK8&key=AIzaSyAjE0VJZRVwo1tDD42y0zSR0C_g9yq6XdA" allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <br/><br/><br/><br/>
                    
                <Footer/>
            </div>
        )
    }
}
